/// <reference path="../../typings/tsd.d.ts" /> 
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ProcessTypeService = /** @class */ (function (_super) {
            __extends(ProcessTypeService, _super);
            function ProcessTypeService(injectedBreeze, $q, $http, processSubTypeService) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.processSubTypeService = processSubTypeService;
                return _this;
            }
            ProcessTypeService.prototype.getActiveProcessTypesNonBreeze = function () {
                var d = this.$q.defer();
                this.$http.get('./api/ProcessType/ActiveProcessTypes').then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            ProcessTypeService.prototype.getExecutionProcessTypes = function () {
                var d = this.$q.defer();
                this.$http.get('./api/ProcessType').then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            ProcessTypeService.prototype.getExecutionProcessType = function (id) {
                var d = this.$q.defer();
                this.$http.get('./api/ProcessType/' + id).then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            ProcessTypeService.prototype.getActiveProcessTypes = function () {
                var defer = this.$q.defer();
                var query = this.breezeModule.EntityQuery
                    .from("ProcessTypes")
                    .expand("processConfigurations")
                    .orderBy("name");
                this.executeQuery(query).then(function (processTypes) {
                    var activeProcessTypes = [];
                    for (var i = 0; i < processTypes.length; i++) {
                        var currentProcessType = processTypes[i];
                        if (Enumerable.from(currentProcessType.processConfigurations).any(function (x) { return x.minorVersion != null && x.configurationStatus === 2 /* Active */; })) {
                            activeProcessTypes.push(currentProcessType);
                        }
                    }
                    defer.resolve(activeProcessTypes);
                });
                return defer.promise;
            };
            ProcessTypeService.prototype.getChildProcessTypes = function () {
                var predicate = new this.breezeModule.Predicate("isChildProcess", "==", true)
                    .and("isEmbedded", "==", false);
                var query = this.breezeModule.EntityQuery
                    .from("ProcessTypes")
                    .where(predicate)
                    .orderBy("name");
                return this.executeQuery(query);
            };
            ProcessTypeService.prototype.getConfigurationChildProcesses = function (configurationId) {
                var d = this.$q.defer();
                var query = this.breezeModule.EntityQuery
                    .from("ChildProcesses");
                query = query.where("processConfiguration_id", "==", configurationId);
                query = query.expand("processType.processConfigurations")
                    .orderBy("processType.name");
                this.executeQuery(query).then(function (result) {
                    var processTypes = [];
                    result.forEach(function (childProcess) {
                        processTypes.push(childProcess.processType);
                    });
                    d.resolve(processTypes);
                });
                return d.promise;
            };
            ProcessTypeService.prototype.getAllProcessTypes = function () {
                var query = this.breezeModule.EntityQuery
                    .from("ProcessTypes");
                query = query.where("isEmbedded", "==", false);
                query = query.expand("processConfigurations")
                    .orderBy("name");
                return this.executeQuery(query);
            };
            ProcessTypeService.prototype.getProcessTypeById = function (id) {
                var query = this.breezeModule.EntityQuery
                    .from("ProcessTypes")
                    .where("id", "==", id);
                return this.fetch(query);
            };
            ProcessTypeService.prototype.copyProcessType = function (id) {
                var _this = this;
                var handlerUrl = "api/ProcessType/" + id + "/Copy";
                var result = this.$http.post(handlerUrl, undefined)
                    .then(function (response) { return _this.handlerResponded(response, undefined); });
                return result;
            };
            ProcessTypeService.prototype.createProcessConfiguration = function (processType) {
                var processConfig = this.createNewEntity("ProcessConfiguration", { myProcessType: processType });
                var statusCodeGroup = this.createNewEntity("StatusCodeGroup");
                statusCodeGroup.processConfiguration_id = processConfig.id;
                statusCodeGroup.shortDescription = "Process Level Status Group";
                processConfig.myStatusCodeGroup = statusCodeGroup;
                processConfig.statusCodeGroup_id = statusCodeGroup.id;
                var processInitiatorClaim = this.createProcessInitiatorProcessClaimDefinition();
                processConfig.myClaims.push(processInitiatorClaim);
                processInitiatorClaim.processConfiguration_id = processConfig.id;
                this.processSubTypeService.createConfig(processConfig);
                this.createInitialStatusAndState(processConfig);
                return processConfig;
            };
            ProcessTypeService.prototype.createInitialStatusAndState = function (processConfig) {
                var newStatus = this.createNewEntity("StatusCode");
                newStatus.uniqueIdentifier = services.UtilityService.generateGuidComb();
                newStatus.isInitialStatus = true;
                newStatus.isSystemLevel = false;
                newStatus.shortDescription = "Initial Status";
                newStatus.myParentStatusGroup = processConfig.myStatusCodeGroup;
                newStatus.parentStatusCodeGroup_id = processConfig.statusCodeGroup_id;
                var newState = this.createNewEntity("StateCode");
                newState.uniqueIdentifier = services.UtilityService.generateGuidComb();
                newState.isInitialState = true;
                newState.isSystemLevel = false;
                newState.shortDescription = "Initial State";
                newState.myParentStatus = newStatus;
                newState.statusCode_id = newStatus.id;
                newStatus.myStates.push(newState);
                var stateInfo = this.createNewEntity("StateInfo");
                stateInfo.myStateCode = newState;
                stateInfo.stateCode_id = newState.id;
                var stateWorkflowBlock = this.createNewEntity("StateWorkflowBlock");
                stateWorkflowBlock.blockType = 0 /* State */;
                stateWorkflowBlock.name = "Initial State";
                stateWorkflowBlock.uniqueIdentifier = services.UtilityService.generateGuidComb();
                stateWorkflowBlock.isInitialWorkflowBlock = true;
                stateWorkflowBlock.myStatus = newStatus;
                stateWorkflowBlock.statusCode_id = newStatus.id;
                stateWorkflowBlock.stateInfo_id = stateInfo.id;
                stateWorkflowBlock.myStateInfo = stateInfo;
                newState.stateWorkflowBlockId = stateWorkflowBlock.id;
                newStatus.myWorkflowBlocks.push(stateWorkflowBlock);
                processConfig.myStatusCodeGroup.myStatuses.push(newStatus);
            };
            ProcessTypeService.prototype.createProcessInitiatorProcessClaimDefinition = function () {
                var claimDefinition = this.createNewEntity("ClaimDefinition");
                claimDefinition.specialClaimTagType = 2 /* ProcessInitiator */;
                claimDefinition.maxAssignments = 1;
                claimDefinition.type = "Process Initiator";
                claimDefinition.valueAssignable = false;
                claimDefinition.valueType = 11 /* None */;
                claimDefinition.uniqueIdentifier = "89877FB0-0816-4263-947D-0159B7CC7AD2";
                return claimDefinition;
            };
            ProcessTypeService.prototype.createProcessType = function () {
                return this.createNewEntity("ProcessType");
            };
            ProcessTypeService.prototype.createChildProcess = function () {
                return this.createNewEntity("ChildProcess");
            };
            ProcessTypeService.prototype.getByIdEagerLoadAppConfigs = function (processTypeId) {
                var query = this.breezeModule.EntityQuery
                    .from("ProcessTypes")
                    .where("id", "==", processTypeId)
                    .expand("processConfigurations");
                return this.fetch(query);
            };
            ProcessTypeService.prototype.getActiveProcessTypeAndSecurity = function (id) {
                var query = this.breezeModule.EntityQuery
                    .from("ProcessTypes")
                    .expand("processConfigurations, processConfigurations.mySecurityMatrices")
                    .where("id", "==", id)
                    .orderBy("name");
                return this.fetch(query);
            };
            return ProcessTypeService;
        }(services.DataService));
        services.ProcessTypeService = ProcessTypeService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ProcessTypeService', ['breeze', '$q', '$http', "processSubTypeService"]);
